module.exports = __webpack_public_path__ + "static/media/diet_coming_soon.4a4d367a.png";